import { render, staticRenderFns } from "./ProviderRegionList.vue?vue&type=template&id=66240e1c"
import script from "./ProviderRegionList.vue?vue&type=script&lang=js"
export * from "./ProviderRegionList.vue?vue&type=script&lang=js"
import style0 from "./ProviderRegionList.vue?vue&type=style&index=0&id=66240e1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports